const noop = () => {};
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
};

export default logger;
